import { DataModel } from '../../dto/dto.js';
import { Fee } from '../fee.js';
import { InvoiceVat } from '../invoicing/invoice-vat.js';
import { Price } from '../price.js';

export abstract class ApplicationFeeProtocol extends DataModel {
  abstract get overrideVat(): InvoiceVat | null;
  abstract getUnitFee(unitPrice: Price): Fee | null;
  abstract calculateUnitFee(unitPrice: Price): Price;
}
